export enum ErrorCode {
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  NOT_FOUND = 'NOT_FOUND',
  RATE_LIMIT = 'RATE_LIMIT',
  VALIDATION = 'VALIDATION',
  INTERNAL_SERVER = 'INTERNAL_SERVER',
  CONFLICT = 'CONFLICT',
}

interface ErrorResponse {
  message: string
  code: ErrorCode
  status: number
  error?: unknown
}

const ERROR_MESSAGES: Record<ErrorCode, { message: string; status: number }> = {
  [ErrorCode.UNAUTHORIZED]: {
    message: 'Authentication required',
    status: 401,
  },
  [ErrorCode.FORBIDDEN]: {
    message: 'Access denied',
    status: 403,
  },
  [ErrorCode.NOT_FOUND]: {
    message: 'Resource not found',
    status: 404,
  },
  [ErrorCode.RATE_LIMIT]: {
    message: 'Too many requests',
    status: 429,
  },
  [ErrorCode.VALIDATION]: {
    message: 'Validation error',
    status: 400,
  },
  [ErrorCode.CONFLICT]: {
    message: 'Conflict',
    status: 409,
  },
  [ErrorCode.INTERNAL_SERVER]: {
    message: 'Internal server error',
    status: 500,
  },
}

export function handleError(
  code: ErrorCode,
  customMessage?: string,
  error?: unknown
): ErrorResponse {
  const { message, status } = ERROR_MESSAGES[code]

  // Log error details if present
  if (error) {
    console.error({
      code,
      message: customMessage || message,
      error,
      timestamp: new Date().toISOString(),
    })
  }

  return {
    message: customMessage || message,
    code,
    status,
    ...(error && process.env.NODE_ENV !== 'production' ? { error } : {}),
  }
}
